import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { OnboardingLayout } from '../Layout/Layout'

import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'
import { LinkButton } from '@percent/domain/giving'
import { getAccountFromAuthState } from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'
import { useAuth } from '@percent/workplace-giving/common/hooks/useAuth/useAuth'
import { useAnalytics } from '@percent/workplace-giving/common/hooks/useAnalytics/useAnalytics'
import { Box } from '@percent/lemonade'
import classes from './OnboardingSuccess.module.scss'

function OnboardingSuccessHeader() {
  return (
    <Box className={classes.headerWrapper}>
      <Box className={classes.headerIconWrapper}>
        <span className={classes.headerIcon} aria-hidden="true">
          👋
        </span>
      </Box>
    </Box>
  )
}

export function OnboardingSuccess() {
  const { t } = useTranslation()
  const { search } = useLocation()
  const { track } = useAnalytics()

  const { state } = useAuth()
  const user = getAccountFromAuthState(state)

  const redirectTo = (() => {
    const urlParams = new URLSearchParams(search)

    let r = urlParams.get('redirect_to') ?? AppRoute.HOME

    // can be weird if you go to the screen directly, so just making sure the redirect url is clean
    if (r.includes(AppRoute.ONBOARDING_SUCCESS)) {
      r = AppRoute.HOME
    }

    urlParams.delete('redirect_to')

    urlParams.set('finished_onboarding', 'true')

    return `${r}?${urlParams.toString()}`
  })()

  return (
    <OnboardingLayout
      cardTitle={t('workplace_giving.onboarding.success.title', { name: user?.preferredName ?? user?.fullName })}
      cardDescription={t('workplace_giving.onboarding.success.description')}
      cardHeader={<OnboardingSuccessHeader />}
      footer={
        <LinkButton
          to={redirectTo}
          variant="primary"
          shape="oval"
          replace
          stretch
          onClick={() => track({ event: 'Onboarding Start Exploring CTA Clicked' })}
        >
          {t('workplace_giving.onboarding.success.ctaLabel')}
        </LinkButton>
      }
    />
  )
}
